/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgPresentationBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9998 20.2V16.8M11.9998 20.2C12.6638 20.2 13.2006 20.5599 13.2006 20.9999M11.9998 20.2C11.3358 20.2 10.8006 20.5599 10.8006 20.9999M3 16.8H20.9999M3.6 3H20.3999C20.7313 3 20.9999 3.26863 20.9999 3.6V5.59998C20.9999 5.93135 20.7313 6.19998 20.3999 6.19998H3.6C3.26863 6.19998 3 5.93135 3 5.59998V3.6C3 3.26863 3.26863 3 3.6 3ZM4.19914 6.20002H19.799V16.8H4.19914V6.20002Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgPresentation = wrapIcon(SvgPresentationBase);
export default SvgPresentation;
